import { AlignJustify } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { SidebarContent } from "./sidebar/SidebarContent";

interface HeaderMobileNavProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  isAdmin: boolean;
}

/**
 * Header Mobile Nav.
 */
export function HeaderMobileNav({ isOpen, onOpenChange, isAdmin }: Readonly<HeaderMobileNavProps>) {
  return (
    <Sheet open={isOpen} onOpenChange={onOpenChange}>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" className="sm:hidden h-9 w-9 p-0">
          <AlignJustify className="h-5 w-5" />
          <span className="sr-only">Open navigation menu</span>
        </Button>
      </SheetTrigger>
      <SheetContent
        side="left"
        className="w-[320px] p-0 bg-background border-border overflow-y-auto flex flex-col max-h-screen"
      >
        <SheetTitle className="sr-only">Navigation menu</SheetTitle>
        <SidebarContent
          pathname=""
          isAdmin={isAdmin}
          isCollapsed={false}
          toggleSidebar={() => {}}
          setIsMenuOpen={onOpenChange}
          isMobile={true}
        />
      </SheetContent>
    </Sheet>
  );
}
